module.exports = __webpack_public_path__ + "media/img/pages/companies/lonza-53534508815f26d055fb243dada240a7.jpg";